import { ko } from 'enova-web-common';

export default function MenuViewModel(options) {
  const self = this;

  options = options || {};
  const oneMenuAtOnce = options.oneMenuAtOnce || false;

  self.isHelpOpen = ko.observable(false);
  self.isLangOpen = ko.observable(false);
  self.isMenuOpen = ko.observable(false);

  self.toggleHelp = (vm, e) => {
    const shouldOpen = !self.isHelpOpen();
    if (shouldOpen) {
      self.isLangOpen(false);
    }
    self.isHelpOpen(shouldOpen);

    if (oneMenuAtOnce) {
      if (shouldOpen && self.isMenuOpen()) {
        self.isMenuOpen(false);
      }
    }

    if (!oneMenuAtOnce) {
      e.stopPropagation();
    }

    return true; // let clicks bubble to links in the html
  };

  self.toggleLang = (vm, e) => {
    const shouldOpen = !self.isLangOpen();
    if (shouldOpen) {
      self.isHelpOpen(false);
    }
    self.isLangOpen(shouldOpen);

    if (oneMenuAtOnce) {
      if (shouldOpen && self.isMenuOpen()) {
        self.isMenuOpen(false);
      }
    }

    if (!oneMenuAtOnce) {
      e.stopPropagation();
    }

    return true; // let clicks bubble to links in the html
  };

  self.toggleMenu = (vm, e) => {
    const shouldOpen = !self.isMenuOpen();
    self.isMenuOpen(shouldOpen);

    if (oneMenuAtOnce) {
      if (shouldOpen && (self.isHelpOpen() || self.isLangOpen())) {
        self.isHelpOpen(false);
        self.isLangOpen(false);
      }
    }

    if (!oneMenuAtOnce) {
      e.stopPropagation();
    }

    return true; // let clicks bubble to links in the html
  };
}
